export const formatSort = (sort) => {
  if (!sort) return null;
  return Object.entries(sort)
    .map(([key, value]) => `${key}:${value}`)
    .join(',');
};
